// removed by extract-text-webpack-plugin
module.exports = {"table-wrapper":"PresetList__table-wrapper___3zjj6","preset-list":"PresetList__preset-list___2UNlg","is-active":"PresetList__is-active___1Zla5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DevicePage/PresetList/PresetList.css
// module id = 353
// module chunks = 0